import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { getCookie } from "@/utils";

interface UserInfoDTO {
  phone: string;
  vcode: string;
  referral: string;
}

const useChatPluginStore = defineStore("userInfo", () => {
  const currentUserInfo = ref<UserInfoDTO>({} as UserInfoDTO);

  const loginStatus = ref<boolean>(!!getCookie("Authorization"));

  const currentChatPluginData: any = computed(() => currentUserInfo.value);

  const setUserInfo = (data: any) => {
    currentUserInfo.value = data;
  };
  const setLoginStatus = (status: boolean) => {
    loginStatus.value = status;
  };
  const topBarWords = ref<string>("可梦AI");
  const setTopBarWords = (str: string) => {
    topBarWords.value = str;
  };
  const showSelectStatus = ref<boolean>(true);
  const setShowSelectStatus = (status: boolean) => {
    showSelectStatus.value = status;
  };
  return {
    currentChatPluginData,
    currentUserInfo,
    setUserInfo,
    loginStatus, //展示
    setLoginStatus, //设置
    showSelectStatus,
    setShowSelectStatus,
    topBarWords,
    setTopBarWords,
  };
});

export default useChatPluginStore;
